/*
 * @LastEditors: zhanglinju
 */
/*
 * @LastEditors: zhanglinju
 */
import yxpapi from '@yxpapi';

const api = new yxpapi.PHPAPI({
    // 获取轮播图
    getrotationInfoList: {
        url: '/api/crm/preview/rotationInfo',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },

    },
    // 获取栏目列表
    getcatalogList: {
        url: '/api/crm/preview/catalogList',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },

    },
    // 获取栏目详情
    catalogDetail: {
        url: '/api/crm/preview/catalogDetail',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    // 获取code
    getSiteByCode: {
        url: '/api/crm/common/getSiteByCode',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getPageManagePlugList: {
        url: '/api/crm/plug/list',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getWebSiteAddress: {
        url: '/api/crm/common/getWebSiteAddress',
        method: 'get',
        // options: {
        //     headers: {
        //         authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
        //         orgId: '1',
        //     },
        //     auth: false,
        // },
    },
    getInfoCintent: {
        url: '/api/crm/website/content/getInfo',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getWxurl: {
        url: 'https://wechat-api.anoah.com/api/wechat/getJsSdk',
        method: 'get',
        options: {
            auth: false,
            errorTip: false,
        },
    },
    // 分页获取内容列表
    getPageList: {
        url: '/api/crm/website/content/pageList',
        method: 'post',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
        },
    },
    /* 获取站点信息 */
    websiteInfo: {
        url: '/api/crm/website/info',
        method: 'get',
    },
});

export default api;
